import { restClient } from '@/Core'

import { notificationManager } from '../Stores/NotificationManager'

// Fetch unread count for a given type filter via meta.total (limit=1).
const fetchUnreadCount = async (types: string[]): Promise<number> => {
    // forceRefresh: counts must reflect the latest read/unread state, not
    // RestClient's ~30s cached GET (otherwise tab badges flip back).
    const response = (await restClient.get(
        '/services/user/notifications',
        {
            searchParams: {
                page: 1,
                limit: 1,
                filters: JSON.stringify({
                    and: [
                        { field: 'isReaded', op: '=', value: false },
                        { field: 'type', op: 'in', value: types },
                    ],
                }),
            },
        },
        { forceRefresh: true }
    )) as { meta?: { total?: number } }

    return response?.meta?.total ?? 0
}

// Loads per-tab unread counters for the notifications page.
// tasks — type IN (system, task); dispatcher — type = dispatcher.
export const LoadTabUnreadCountsTask = async () => {
    try {
        const [tasksCount, dispatcherCount] = await Promise.all([
            fetchUnreadCount(['system', 'task']),
            fetchUnreadCount(['dispatcher']),
        ])

        notificationManager.setUnreadTasksCount(tasksCount)
        notificationManager.setUnreadDispatcherCount(dispatcherCount)
    } catch {
        // Silently ignore — tab badges just won't update
    }
}
